<template>
  <div>
    <table class="tabular-header v-datatable v-table v-datatable--select-all theme--light" ref="headerTable">
      <thead>
        <!-- <tr v-if="isLoading" class="v-datatable__progress">
          <th colspan="7" class="column">
            <v-progress-linear v-if="isLoading" />
          </th>
        </tr> -->
        <tr class="virtual-scroll-table__header">
          <th v-if="checkbox" :width="hardCodedSelectWidth">
            <div class="v-input v-input--selection-controls v-input--checkbox v-input--hide-details theme--light" primary="">
              <div class="v-input__control">
                <div class="v-input__slot">
                  <!-- TODO -->
                  <v-checkbox />
                </div>
              </div>
            </div>
          </th>
          <template v-for="(header, index) in headers">
            <template v-if="disableSlicedHeaders">
              <th :key="`th-${index}`" :style="getMaxWidth(header.text, getHeader(index))">{{header.text}}</th>
            </template>
            <SlicedHeader v-else :headerStyle="getMaxWidth(header.text, getHeader(index))" :key="`th-${index}`" ref="slicedHeaders" :header="header" @slice="onSlice()" :sortable="!!header.sorter" :active="isActiveSort(header)" :descending="sort.descending" @sort="onSort(header)" :data="items" :disabled="isLoading || isSaving" :slowMode="slowMode" />
          </template>
          <th :style="{'width': scrollWidth + 'px'}" />
        </tr>
      </thead>
      <slot name="no-data" v-bind:noData="noData" v-bind:isLoading="isLoading">
        <v-alert type="warning" :value="noData&&!isLoading">Oops, there's no data to show. This shouldn't be happening -
          please let us
          know.</v-alert>
      </slot>
      <tbody v-if="isLoading" :style="`display: block; height: ${optimalTableHeight}px;`" data-ui-component="skeletonLoaders">
        <div class="cell-container" style="height: 48px;" v-for="i in skeletonDataItems" :key="`row-${i}`">
          <v-layout class="row">
            <template v-for="(header, index) in headers">
              <v-flex :key="`cell-${index}`" :id="`cell${header.value}`" :class="`cell cell${header.value}`" :style="getMaxWidth(header.text, getHeader(index))">
                <div class="loading-skeleton-1">{{ header.text }}</div>
              </v-flex>
            </template>
          </v-layout>
        </div>
      </tbody>
    </table>
    <VirtualList v-if="!isLoading" :size="rowHeight" :remain="numberOfRowsToDisplay" rtag="table" wtag="tbody" ref="bodyTable" class="v-datatable v-table v-datatable--select-all theme--light no-x-scroll">
      <tr v-for="(row, i) in items" :key="`data-row-${i}`" class="virtual-scroll-table__row" @click="onVirtualListClick">
        <td v-if="checkbox" :width="hardCodedSelectWidth">
          <div class="v-input v-input--selection-controls v-input--checkbox v-input--hide-details theme--light" primary="">
            <div class="v-input__control">
              <div class="v-input__slot">
                <v-checkbox />
              </div>
            </div>
          </div>
        </td>
        <td v-for="(header, j) in headers" :key="`td-row_${i}-col_${j}`" :style="getMaxWidth(header.text, getHeader(j))" :id="formatCellId(header, row.data)" class="virtual-scroll-table__cell">
          <slot v-bind:header="header" v-bind:row="row">
            {{ accessItemValue(header, row.data) }}
          </slot>
        </td>
      </tr>
    </VirtualList>
  </div>
</template>

<script>
  import virtualList from 'vue-virtual-scroll-list'
  import VirtualCollectionUtil from '@/components/mixins/VirtualCollectionUtil'
  import VirtualScrollTableRow from '@/components/generic/VirtualScroll/VirtualScrollTableRow'
  import {
    getScrollbarSize,
  } from '@/helpers/dom'

  const TableHeaderHeight = 56
  const TableRowHeight = 48
  export default {
    components: {
      VirtualList: virtualList,
    },
    mixins: [VirtualCollectionUtil],
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      // {
      //    text: string,
      //    align: string, [center, left, right]
      //    format: (val: string) -> string
      //    accessor: (row: any) -> string|number|datetime
      //    value: string,
      //    sorter: sorter    
      // }
      // 
      // Specify either accessor or value, if both are provided, accessor is used
      headers: {
        type: Array,
        default: () => [],
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      isSaving: {
        type: Boolean,
        default: false,
      },
      checkbox: {
        type: Boolean,
        default: false,
      },
      sort: {
        type: Object,
        default: () => {},
      },
      slowMode: {
        type: Boolean,
        default: false,
      },
      optimalHeight: {
        type: String | Number,
        default: 500,
      },
      disableSlicedHeaders: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        rowComponent: VirtualScrollTableRow,
        hardCodedSelectWidth: 30,
        rowHeight: TableRowHeight,
        skeletonDataItems: 3,
      }
    },
    computed: {
      itemAndHeaders() {
        return this.items.map((x, i) => ({
          uid: i,
          headers: this.headers,
          ...x,
        }))
      },
      numberOfRowsToDisplay() {
        const height = Number.parseInt(this.optimalHeight, 10)
        return Math.floor(height / TableRowHeight)
      },
      noData() {
        return ((this.items && this.items.length) || 0) == 0
      },
      scrollWidth() {
        const {
          width,
          // height,
        } = getScrollbarSize()
        return width
      },
      optimalTableHeight() {
        return this.optimalHeight - TableHeaderHeight
      },
    },
    watch: {
      items() {
        this.updateMaxWidths(this.headers, this.items)
        this.$emit('resize', this.dom.totalWidth)
      },
    },
    methods: {
      getHeader(index) {
        return this.headers[index]
      },
      // onSort(header) {
      //   // TOOD
      // },
      // onSlice(header) {
      //   // TOOD
      // },
      // isActiveSort(header) {
      //   // TODO
      //   return false
      // },
      syncScroll() {
        let header = this.$refs.headerTable
        let body = this.$refs.bodyTable.$el

        body.onscroll = function() {
          header.scrollLeft = this.scrollLeft
        }
      },
      onVirtualListClick(event) {
        this.$emit('click', event)
      },
      formatCellId(header, data) {
        let dataId = (header && header.idAccessor && header.idAccessor(data)) || data.Id
        return `cell${header.value}-${dataId}`
      },
    },
    mounted() {
      this.syncScroll()
    },
  }
</script>
<style scoped>
  .virtual-scroll-table__header {
    align-items: center;
    position: relative;
  }

  .virtual-scroll-table__row {
    display: flex;
    width: fit-content;
  }

  .virtual-scroll-table__cell {
    display: flex;
  }

  .tabular-header {
    display: block;
    /* overflow-x: hidden; */
    /* overflow-y: scroll; */
  }

  .no-x-scroll {
    overflow-x: hidden;
  }

  .v-datatable>tbody {
    width: fit-content;
  }

  @-webkit-keyframes gradientanimation {
    0% {
      background-position: 0% 31%;
    }

    50% {
      background-position: 100% 70%;
    }

    100% {
      background-position: 0% 31%;
    }
  }

  @-moz-keyframes gradientanimation {
    0% {
      background-position: 0% 31%;
    }

    50% {
      background-position: 100% 70%;
    }

    100% {
      background-position: 0% 31%;
    }
  }

  @keyframes gradientanimation {
    0% {
      background-position: 0% 31%;
    }

    50% {
      background-position: 100% 70%;
    }

    100% {
      background-position: 0% 31%;
    }
  }
</style>